import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import Notification from "components/common/notification/notification";
import {HeaderPrintForm, InfoItem, Sign} from "components/common/PrintForm";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {columns} from "./config";
import {
  birthday2Age,
  checkEmptyObj,
  convertIosStringToDateDayjs,
  formatDateToString,
  toNumber,
} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import {nurseOutService, catalogService} from "api";
import {checkEmptyObjVitalSigns, renderViTriMat} from "helper/nurseOut";
import {getListDoiTuongAPI} from "redux/reducer/common";
import "./NurseOutModal.scss";
import {useReactToPrint} from "react-to-print";
import {HeaderCustom} from "components/common";
import VitalSigns from "../component/VitalSigns/VitalSigns";
import {listWarningPunctumSyringing} from "pages/NurseOut/DetailPatient/components/NurseInfo/config";
import SearchPatientService from "api/searchPatient";
const NurseOutModal = props => {
  const dispatch = useAppDispatch();
  const {closeModal} = props;
  const printRef = useRef<any>();
  const printRef2 = useRef<any>();
  const tienSuBenhRef = useRef<any>(null);
  const idPhieu = useAppSelector(state => state.nurseOut.idReceipt);
  const [detailPhieu, setDetailPhieu] = useState<any>();
  const [lichSuTra, setLichSuTra] = useState<any[]>([]);
  const [dataNurse, setDataNurse] = useState<any>();
  const [content, setContent] = useState<any>();
  useEffect(() => {
    dispatch(getListDoiTuongAPI());
  }, []);
  const [dataTable, setDataTable] = useState<any[]>([
    {benhSu: "Bệnh sử", ghiChu: ""},
    {benhSu: "Tiền sử bệnh nhãn khoa", ghiChu: ""},
    {benhSu: "Tiền sử bệnh toàn thân", ghiChu: ""},
    {benhSu: "Tiền sử dị ứng thuốc", ghiChu: ""},
    {benhSu: "Tiền sử dị ứng thực phẩm", ghiChu: ""},
  ]);
  const fields1: any[] = [
    {label: "Họ và tên", value: detailPhieu?.hoTen?.toString()?.toUpperCase()},
    {
      label: "Ngày sinh  - Giới tính",
      value: `${formatDateToString(
        convertIosStringToDateDayjs(detailPhieu?.ngaySinh),
        FORMAT_TIME.dayFull
      )}  - ${detailPhieu?.gioiTinh == 0 ? "Nam" : "Nữ"}`,
    },
    {label: "Điện thoại", value: detailPhieu?.dienThoai},
    {label: "Địa chỉ", value: detailPhieu?.diaChiTongHop, span: 5},
  ];
  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(detailPhieu?.thoiGianKham),
    },
    {label: "Mã bệnh nhân", value: detailPhieu?.maBenhNhan},
    {label: "Mã phiếu khám", value: detailPhieu?.idPhieuKham},
    {label: "Lý do khám", value: detailPhieu?.lyDoKham},
  ];
  useEffect(() => {
    if (detailPhieu?.jsonDieuDuongDto) {
      parseJsonValueToObject(detailPhieu?.jsonDieuDuongDto);
    }
  }, [detailPhieu]);
  useEffect(() => {
    if (idPhieu != null) {
      getNurseForm(idPhieu);
      getListLichsuTraThuoc(idPhieu);
    }
  }, [idPhieu]);
  const getListLichsuTraThuoc = async idPhieu => {
    try {
      const res = await SearchPatientService.getListLichsuTraThuoc(idPhieu);
      setLichSuTra(res);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi khi lấy thông tin lịch sử tra thuốc của phiếu"
      );
    }
  };
  const getNurseForm = async id => {
    if (id != null) {
      try {
        const res = await SearchPatientService.getNurseForm(id);
        setDetailPhieu(res);
      } catch (error) {
        Notification("error", "Đã có lỗi khi lấy thông tin phiếu");
      }
    }
  };
  const parseJsonValueToObject = dataJson => {
    const data = {
      ...dataJson,
      chiefComplaints: JSON.parse(dataJson?.chiefComplaints),
      contactAllergies: JSON.parse(dataJson?.contactAllergies),
      intraocularPressure: JSON.parse(dataJson?.intraocularPressure) || {
        ["intraocularPressureRight"]: null,
        ["intraocularPressureLeft"]: null,
      },
      ophthalmicHistory: JSON.parse(dataJson?.ophthalmicHistory),
      drugAllergies: JSON.parse(dataJson?.drugAllergies),
      foodAllergies: JSON.parse(dataJson?.foodAllergies),
      systemicHistory: JSON.parse(dataJson?.systemicHistory),
      vitalSigns: JSON.parse(dataJson?.vitalSigns),
      syringing: JSON.parse(dataJson?.syringing),
      randomBloodSugar: JSON.parse(dataJson?.randomBloodSugar),
    };
    let dataTable = [];
    if (data?.chiefComplaints?.Comments) {
      dataTable.push({
        benhSu: "Bệnh sử",
        ghiChu: data?.chiefComplaints?.Comments,
      });
    }
    if (data?.ophthalmicHistory?.Comments) {
      dataTable.push({
        benhSu: "Tiền sử bệnh nhãn khoa",
        ghiChu: data?.ophthalmicHistory?.Comments,
      });
    }
    if (data?.systemicHistory?.Comments) {
      dataTable.push({
        benhSu: "Tiền sử bệnh toàn thân",
        ghiChu: data?.systemicHistory?.Comments,
      });
    }
    if (data?.systemicHistory?.FamilyHistory) {
      dataTable.push({
        benhSu: "Tiền sử gia đình",
        ghiChu: data?.systemicHistory?.FamilyHistory,
      });
    }
    if (data?.systemicHistory?.MedicalHistory) {
      dataTable.push({
        benhSu: "Tiền sử bệnh",
        ghiChu: data?.systemicHistory?.MedicalHistory,
      });
    }
    if (data?.contactAllergies?.DrugAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng thuốc",
        ghiChu: data?.contactAllergies?.DrugAllergiesComment,
      });
    }
    if (data?.contactAllergies?.ContactAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng tiếp xúc",
        ghiChu: data?.contactAllergies?.ContactAllergiesComment,
      });
    }
    if (data?.contactAllergies?.FoodAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng thực phẩm",
        ghiChu: data?.contactAllergies?.FoodAllergiesComment,
      });
    }
    if (data?.foodAllergies?.Comment) {
      dataTable.push({
        benhSu: "Ghi chú khác",
        ghiChu: data?.foodAllergies?.Comment,
      });
    }
    setDataTable([...dataTable]);
    setDataNurse({
      vitalSigns: data?.vitalSigns,
      intraocularPressure: data?.intraocularPressure,
      syringing: data?.syringing,
      randomBloodSugar: data?.randomBloodSugar,
    });
  };

  const syringingInfo = syringingInfo => {
    return [
      {label: "Lệ đạo trên", value: syringingInfo?.LowerPunctum},
      {label: "Lệ đạo dưới", value: syringingInfo?.UpperPunctum},
      {label: "Ghi chú", value: syringingInfo?.Comment},
    ];
  };
  const onPrint = async () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("form-content");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;
      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        const footerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight);
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };

  useEffect(() => {
    handleCheckPrint("tienSuBenh", true);
    handleCheckPrint("dieuDuong", true);
    handleCheckPrint("nhanAp", true);
    handleCheckPrint("leDao", true);
    handleCheckPrint("duongHuyet", true);
    handleCheckPrint("traThuoc", true);
  }, [detailPhieu, dataTable]);
  const handleCheckPrint = (className, show) => {
    const emptyNode = document.createElement("div");
    emptyNode.setAttribute("class", `${className}`);

    let printNode;
    if (show) {
      printNode =
        document
          .querySelectorAll(`div.preview div.${className}`)?.[0]
          ?.cloneNode(true) || emptyNode;
    } else {
      printNode = emptyNode;
    }
    const originNode = document.querySelectorAll(
      `div.print div.${className}`
    )?.[0];
    const printContent = document.getElementById("print-content");
    printContent.replaceChild(printNode, originNode);
    // setContent(printRef2.current);
  };

  const cloneToPrint = () => {
    return printRef2.current;
  };
  return (
    <div className="print-nurse-out">
      <div className="preview">
        <HeaderPrintForm></HeaderPrintForm>
        <div>
          <InfoItem
            fields1={fields1}
            fields2={fields2}
            idBenhNhan={detailPhieu?.maBenhNhan}
            title={"PHIẾU KẾT QUẢ ĐIỀU DƯỠNG NGOẠI TRÚ"}
            isChiefComplant={false}
          />
          {dataTable.length > 0 && (
            <>
              {" "}
              <Checkbox
                defaultChecked={true}
                onChange={e => handleCheckPrint("tienSuBenh", e.target.checked)}
              ></Checkbox>
              <div className="container2 tienSuBenh" style={{marginBottom: 8}}>
                <Row gutter={4}>
                  <Col>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 22,

                        marginBottom: 8,
                      }}
                    >
                      Tiền sử bệnh
                    </Typography.Text>
                  </Col>
                </Row>

                <Table
                  className="table-print"
                  columns={columns}
                  dataSource={dataTable}
                  pagination={false}
                  bordered
                ></Table>
              </div>
            </>
          )}

          {dataNurse && !checkEmptyObjVitalSigns(dataNurse?.vitalSigns) && (
            <>
              <Checkbox
                defaultChecked={true}
                onChange={e => handleCheckPrint("dieuDuong", e.target.checked)}
              ></Checkbox>
              <div className="container3 dieuDuong" style={{marginBottom: 8}}>
                <Row>
                  <Typography.Text
                    style={{
                      fontWeight: "700",
                      fontSize: 22,

                      marginBottom: 2,
                    }}
                  >
                    Thông tin điều dưỡng
                  </Typography.Text>
                </Row>
                <div>
                  <VitalSigns data={dataNurse.vitalSigns}></VitalSigns>
                </div>
              </div>
            </>
          )}
          {((dataNurse &&
            dataNurse?.intraocularPressure &&
            dataNurse?.intraocularPressure[
              '"intraocularPressureLeft"'
            ]?.findIndex(e => e?.mmHg) != -1) ||
            dataNurse?.intraocularPressure[
              '"intraocularPressureRight"'
            ]?.findIndex(e => e?.mmHg) != -1) && (
            <>
              <Checkbox
                defaultChecked={true}
                onChange={e => handleCheckPrint("nhanAp", e.target.checked)}
              ></Checkbox>
              <div className="container4 nhanAp" style={{marginBottom: 8}}>
                <Row>
                  <Typography.Text
                    style={{
                      fontWeight: "700",
                      fontSize: 22,

                      marginBottom: 8,
                    }}
                  >
                    Nhãn áp
                  </Typography.Text>
                </Row>
                <Row
                  gutter={[4, 4]}
                  // style={{paddingLeft: 16, paddingRight: 16}}
                >
                  <Col span={12}>
                    <HeaderCustom title="Mắt phải"></HeaderCustom>
                    {dataNurse && (
                      <Row gutter={[8, 16]} style={{marginTop: 16}}>
                        {dataNurse?.intraocularPressure[
                          '"intraocularPressureLeft"'
                        ]?.map((e, index) => (
                          <>
                            {e?.mmHg && (
                              <Row gutter={[0, 16]}>
                                <Col span={12}>
                                  <Row>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        marginRight: 2,
                                      }}
                                    >
                                      Kết quả:
                                    </span>
                                    <span
                                      style={{
                                        paddingLeft: "5px",
                                        color:
                                          parseInt(e.mmHg) >= 20
                                            ? "red"
                                            : "black",
                                      }}
                                    >
                                      {e?.mmHg} mmHG
                                    </span>
                                  </Row>
                                </Col>{" "}
                                {e?.method && (
                                  <Col span={12}>
                                    <Row>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginRight: 4,
                                        }}
                                      >
                                        Phương pháp:
                                      </span>{" "}
                                      {e?.method ?? "--"}
                                    </Row>
                                  </Col>
                                )}
                                {e?.comment && (
                                  <Col span={24}>
                                    <Row>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginRight: 4,
                                        }}
                                      >
                                        Ghi chú:
                                      </span>{" "}
                                      {e?.comment ?? "--"}
                                    </Row>
                                  </Col>
                                )}
                              </Row>
                            )}
                          </>
                        ))}
                      </Row>
                    )}
                  </Col>
                  <Col span={12}>
                    <HeaderCustom title="Mắt trái"></HeaderCustom>
                    {dataNurse && (
                      <Row gutter={[8, 8]} style={{marginTop: 12}}>
                        {dataNurse?.intraocularPressure[
                          '"intraocularPressureRight"'
                        ]?.map((e, index) => (
                          <>
                            {e?.mmHg && (
                              <Row gutter={[0, 16]}>
                                <Col span={12}>
                                  <Row>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        marginRight: 2,
                                      }}
                                    >
                                      Kết quả:
                                    </span>
                                    <span
                                      style={{
                                        paddingLeft: "5px",
                                        color:
                                          parseInt(e.mmHg) >= 20
                                            ? "red"
                                            : "black",
                                      }}
                                    >
                                      {e?.mmHg} mmHG
                                    </span>
                                  </Row>
                                </Col>{" "}
                                {e?.method && (
                                  <Col span={12}>
                                    <Row>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginRight: 4,
                                        }}
                                      >
                                        Phương pháp:
                                      </span>{" "}
                                      {e?.method ?? "--"}
                                    </Row>
                                  </Col>
                                )}
                                {e?.comment && (
                                  <Col span={24}>
                                    <Row>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginRight: 4,
                                        }}
                                      >
                                        Ghi chú:
                                      </span>{" "}
                                      {e?.comment ?? "--"}
                                    </Row>
                                  </Col>
                                )}
                              </Row>
                            )}
                          </>
                        ))}
                      </Row>
                    )}
                  </Col>
                </Row>
              </div>
            </>
          )}
          {dataNurse &&
            dataNurse?.syringing &&
            (syringingInfo(dataNurse.syringing?.L)?.findIndex(e => e?.value) !=
              -1 ||
              syringingInfo(dataNurse.syringing?.R)?.findIndex(e => e?.value) !=
                -1) && (
              <>
                <Checkbox
                  defaultChecked={true}
                  onChange={e => handleCheckPrint("leDao", e.target.checked)}
                ></Checkbox>
                <div className="container5 leDao" style={{marginBottom: 8}}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 22,

                        marginBottom: 8,
                      }}
                    >
                      Lệ đạo
                    </Typography.Text>
                  </Row>
                  <Row
                    gutter={[4, 4]}
                    // style={{paddingLeft: 16, paddingRight: 16}}
                  >
                    <Col span={12}>
                      <HeaderCustom title="Mắt phải"></HeaderCustom>

                      <>
                        {syringingInfo(dataNurse.syringing?.L).map(e => (
                          <>
                            {e?.value && (
                              <Row>
                                <span
                                  style={{fontWeight: "600", marginRight: 4}}
                                >
                                  {`${e.label}:`}{" "}
                                </span>{" "}
                                <span
                                  style={{
                                    color:
                                      listWarningPunctumSyringing.includes(
                                        e.value
                                      ) || e.label == "Ghi chú"
                                        ? "black"
                                        : "red",
                                  }}
                                >
                                  {" "}
                                  {e.value}
                                </span>
                              </Row>
                            )}
                          </>
                        ))}
                      </>
                    </Col>
                    <Col span={12}>
                      <HeaderCustom title="Mắt trái"></HeaderCustom>
                      <>
                        {syringingInfo(dataNurse.syringing?.R).map(e => (
                          <>
                            {e?.value && (
                              <Row>
                                <span
                                  style={{fontWeight: "600", marginRight: 4}}
                                >
                                  {`${e.label}:`}{" "}
                                </span>{" "}
                                <span
                                  style={{
                                    color:
                                      listWarningPunctumSyringing.includes(
                                        e.value
                                      ) || e.label == "Ghi chú"
                                        ? "black"
                                        : "red",
                                  }}
                                >
                                  {" "}
                                  {e.value}
                                </span>
                              </Row>
                            )}
                          </>
                        ))}
                      </>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          {dataNurse &&
            dataNurse?.randomBloodSugar &&
            dataNurse.randomBloodSugar?.Result?.findIndex(e => e?.mmHg) !=
              -1 && (
              <>
                <Checkbox
                  defaultChecked={true}
                  onChange={e =>
                    handleCheckPrint("duongHuyet", e.target.checked)
                  }
                ></Checkbox>
                <div
                  className="container6 duongHuyet"
                  style={{marginBottom: 8}}
                >
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 22,

                        marginBottom: 8,
                      }}
                    >
                      Đường huyết
                    </Typography.Text>
                  </Row>
                  <Row
                    gutter={[4, 4]}
                    // style={{paddingLeft: 16, paddingRight: 16}}
                  >
                    <Row gutter={[4, 4]}>
                      {dataNurse.randomBloodSugar?.Result?.map((e, index) => (
                        <>
                          {e?.mmHg && (
                            <Row gutter={[4, 4]}>
                              <Col span={12}>
                                <Row>
                                  <span
                                    style={{
                                      marginRight: 4,
                                    }}
                                  >
                                    • Kết quả:
                                  </span>{" "}
                                  <span
                                    style={{
                                      color:
                                        toNumber(e?.mmHg) >= 3.9 &&
                                        toNumber(e?.mmHg) <= 7
                                          ? "black"
                                          : "red",
                                    }}
                                  >
                                    {e?.mmHg} mmol/L
                                  </span>
                                </Row>
                              </Col>
                              {/* {e?.min && (
                                <Col span={8}>
                                  <Row>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        marginRight: 4,
                                      }}
                                    >
                                      Thời gian:
                                    </span>{" "}
                                    {e?.min}
                                  </Row>
                                </Col>
                              )}{" "} */}
                              {e?.comment && (
                                <Col span={12}>
                                  <Row>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        marginRight: 4,
                                      }}
                                    >
                                      Ghi chú:
                                    </span>{" "}
                                    {e?.comment ?? "--"}
                                  </Row>
                                </Col>
                              )}{" "}
                            </Row>
                          )}
                        </>
                      ))}
                      {/* <Row>
                      <span style={{fontWeight: "600", marginRight: 4}}>
                        Ghi chú:
                      </span>{" "}
                      {dataNurse.randomBloodSugar?.Comments ?? "--"}
                    </Row> */}
                    </Row>
                  </Row>
                </div>
              </>
            )}

          {lichSuTra.length > 0 && (
            <>
              <Checkbox
                defaultChecked={true}
                onChange={e => handleCheckPrint("traThuoc", e.target.checked)}
              ></Checkbox>
              <div className="container7 traThuoc" style={{marginBottom: 8}}>
                <Row>
                  <Typography.Text
                    style={{
                      fontWeight: "700",
                      fontSize: 22,

                      marginBottom: 8,
                    }}
                  >
                    Tra thuốc
                  </Typography.Text>
                </Row>
                <Row
                  gutter={[4, 4]}
                  // style={{paddingLeft: 16, paddingRight: 16}}
                >
                  {lichSuTra.map(e => (
                    <Row gutter={[4, 4]}>
                      <Col span={8}>
                        <Row>
                          <span style={{fontWeight: "600", marginRight: 4}}>
                            Loại thuốc:
                          </span>{" "}
                          {e?.loaiThuoc ?? "--"}
                        </Row>
                      </Col>{" "}
                      {e?.viTriMat != null && (
                        <Col span={8}>
                          <Row>
                            <span style={{fontWeight: "600", marginRight: 4}}>
                              Vị trí mắt:
                            </span>{" "}
                            {renderViTriMat(e?.viTriMat)}
                          </Row>
                        </Col>
                      )}
                      {e?.nguoiTra && (
                        <Col span={8}>
                          <Row>
                            <span style={{fontWeight: "600", marginRight: 4}}>
                              Người tra:
                            </span>{" "}
                            {e?.nguoiTra}
                          </Row>
                        </Col>
                      )}
                      {e?.ghiChu && (
                        <Col span={8}>
                          <Row>
                            <span style={{fontWeight: "600", marginRight: 4}}>
                              Ghi chú:
                            </span>{" "}
                            {e?.ghiChu}
                          </Row>
                        </Col>
                      )}
                    </Row>
                  ))}
                </Row>
              </div>
            </>
          )}

          <Sign
            span={8}
            nguoiThucHien={detailPhieu?.tenDieuDuong ?? " "}
            time={detailPhieu?.ngayTao}
          ></Sign>
        </div>
      </div>
      <div className="print-containter" style={{display: "none"}}>
        <div ref={printRef2} className="print">
          <table className="table-header">
            <thead className="form-content">
              <tr style={{height: "10px"}}></tr>
              <HeaderPrintForm></HeaderPrintForm>
              <tr style={{height: "30px"}}></tr>
            </thead>
            <tbody>
              <div id="print-content">
                <InfoItem
                  fields1={fields1}
                  fields2={fields2}
                  idBenhNhan={detailPhieu?.maBenhNhan}
                  title={"PHIẾU KẾT QUẢ ĐIỀU DƯỠNG NGOẠI TRÚ"}
                  isChiefComplant={false}
                />
                <div className="tienSuBenh"></div>
                <div className="dieuDuong"> </div>
                <div className="nhanAp"></div>
                <div className="leDao"></div>
                <div className="duongHuyet"></div>
                <div className="traThuoc"></div>

                <Sign
                  span={8}
                  nguoiThucHien={detailPhieu?.tenDieuDuong ?? " "}
                  time={detailPhieu?.ngayTao}
                ></Sign>
              </div>
            </tbody>
            <tfoot className="table-footer" style={{height: "20mm"}}></tfoot>
          </table>
        </div>
      </div>

      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => cloneToPrint()}
            onAfterPrint={closeModal}
            bodyClass="print-nurse-out"
          />
        </Space>
      </Row>
    </div>
  );
};
export default NurseOutModal;
